import { Text } from 'components/UI/Typography/Text';

import styles from './DraftByStarsLegend.module.scss';

export const DraftHistoryLegend = () => {
  return (
    <ul className={styles.legendContainer}>
      <li className={styles.legendItem}>
        <Text variant="h5">Draft Blue Chip Share</Text>
        <Text
          className={styles.description}
          component="span"
          variant="subtitle2"
        >
          <span>The percentage of drafted blue chips owned by the team.</span>
          <span>(Teams&#39;s Draft Bluechips / Total Drafted Blue Chips)</span>
        </Text>
      </li>
      <li>
        <Text variant="h5">
          Draft Talent Ratio <span aria-label="Percentage">%</span>
        </Text>
        <Text
          className={styles.description}
          component="span"
          variant="subtitle2"
        >
          <span>
            The ratio of draft blue chip players to draft eligble players.
          </span>
          <span>(Draft Blue Chip Share / Eligible Players)</span>
        </Text>
      </li>
    </ul>
  );
};
